import type {FullTeamGrid} from './grid/full';
import Icon from '../icon';

interface TeamSelectorElements {
	container: HTMLDivElement;
	selector: HTMLDivElement;
	header: HTMLElement;
	list: HTMLUListElement;
}

export class TeamSelector {
	private readonly elements: TeamSelectorElements = {
		container: document.createElement('div'),
		selector: document.createElement('div'),
		header: document.createElement('header'),
		list: document.createElement('ul')
	};

	constructor(private readonly grid: FullTeamGrid) {
		this.grid.elements.container.append(this.elements.container);
		this.elements.container.append(this.elements.selector);
		this.elements.selector.append(this.elements.header, this.elements.list);
		this.elements.container.classList.add('content');
		this.elements.container.id = 'team-selector-container';
		this.elements.selector.id = 'team-selector';
		this.elements.header.append('Teams', Icon.create('chevron-down'));
		this.elements.header.addEventListener('click', (event) => {
			this.elements.selector.classList.toggle('open');
			event.stopPropagation();
		});
	}

	public load(): void {
		for (const team of this.grid.teams) team.addToList(this.elements.list);
		document.body.addEventListener('click', () => this.close());
	}

	public open(): void {
		this.elements.selector.classList.add('open');
	}

	public close(): void {
		this.elements.selector.classList.remove('open');
	}
}
